import React from 'react';
import Scroll from 'react-scroll';
import { Col, Form, FormControl, Button } from 'react-bootstrap';

import LoginAPI from '../api/LoginAPI'
import RegEx from '../util/RegEx';
import Util from '../util/Util';
import ApiUiController from '../controller/ApiUiController';
import config from '../config/config';

class DeleteAccount extends React.Component {

  constructor(props) {
    super(props);
    this.state = { email: '', inValid: { }, check: false, erase: false, backup: false,
      code: '', conCode: '', confirm: false, confirmCheck: false, inApiCall: false };
  }

  handleChange = (key, value) => {
    const state = { ...this.state};
    state[key] = key === 'email' ? value.toLowerCase() : value;
    this.setState({ ...this.state, ...state });
  }
  
  validate = () => {
    let validate = {};
    if(!RegEx.isMatch(this.state.email, true, RegEx.Email)) {
      validate['email'] = 'Wrong Admin Email';
    }
    if(!this.state.check) {
      validate['check'] = 'Accept terms and conditions.';
      Util.showNotification('Validation', 'Accept terms and conditions', 'danger');
    }
    return validate;
  }

  onSubmit = () => {
    const validate = this.validate();
    const keys =  Object.keys(validate);
    if(keys.length !== 0) {
      this.setState({ ...this.state, inValid: { ...validate }});
      Scroll.scroller.scrollTo(keys[0], { duration: 1500, smooth: true });
    } else {
      this.isError = false;
      this.setState({ ...this.state, inApiCall: true });
      LoginAPI.deleteAccount({ email: this.state.email }, this.success, this.failure);
    }
  }

  onCheckSubmit = () => {
    if(!this.state.confirmCheck) {
      Util.showNotification('Validation', 'Accept terms and conditions', 'danger');
      return;
    }

    if(this.state.code === this.state.confirm) {
      Util.showNotification('Successful', 'Registration successfully.', 'success');
      window.location.href = config.auth;
    } else {
      Util.showNotification('Validation', 'Code dose not match', 'danger');
    }
  }
  failure = response => {
    Util.showNotification('Failure', response.body.message, 'danger');
    this.setState({ ...this.state, inApiCall: false });
  }

  success = res => {
    Util.showNotification('Mail Sent', 'Please check your registered mail for OTP', 'success');
    this.setState({ ...this.state, conCode: res.code, inApiCall: false, confirm: true });
  }
  
  render() {
    return (
      <ApiUiController inApiCall={this.state.inApiCall}>
        <h4 className="regformheading1">Company/User Information</h4>
        <Form.Group as={Col}>
          <label>Admin Email</label>
          { RegEx.showError(this.state.inValid, 'email') }
          <FormControl
            className={RegEx.class(this.state.inValid, 'email')}
            type="email"
            value={this.state.email}
            onChange={event => this.handleChange('email', event.target.value)}
            disabled={this.state.confirm} />
        </Form.Group>
        <br />
        <div className="form-check">
          <input
            type="checkbox"
            id="Check1"
            checked={this.state.check}
            onChange={event => this.handleChange('check', event.target.checked)}
            disabled={this.state.confirm} />
          <label className="form-check-label" htmlFor="Check1">
            &nbsp;&nbsp;I agree to delete my account
          </label>
        </div>
        <div className="form-check">
          <input
            type="checkbox"
            id="Check2"
            checked={this.state.erase}
            onChange={event => this.handleChange('erase', event.target.checked)}
            disabled={this.state.confirm} />
          <label className="form-check-label" htmlFor="Check2">
            &nbsp;&nbsp;I delete my data
          </label>
        </div>
        <div className="form-check">
          <input
            type="checkbox"
            id="Check2"
            checked={this.state.backup}
            onChange={event => this.handleChange('backup', event.target.checked)}
            disabled={this.state.confirm} />
          <label className="form-check-label" htmlFor="Check2">
            &nbsp;&nbsp;Send back up on email
          </label>
        </div>
        <br />
        <Form.Group as={Col}>
          <Button
            onClick={this.onSubmit}
            className="btn btn-danger"
            disabled={this.state.confirm}>
              Delete My Account
          </Button>
        </Form.Group>
        <br />
        { this.state.confirm
          ? <>
            <Form.Group as={Col}>
              <label>Confirmation Code to delete </label>
              { RegEx.showError(this.state.inValid, 'code') }
              <FormControl
                className={RegEx.class(this.state.inValid, 'code')}
                type="number"
                value={this.state.code}
                onChange={event => this.handleChange('code', event.target.value)} />
            </Form.Group>
            <br />
            <div className="form-check">
              <input
                type="checkbox"
                id="Check2"
                checked={this.state.confirmCheck}
                onChange={event => this.handleChange('confirmCheck', event.target.checked)} />
              <label className="form-check-label" htmlFor="Check2">
                &nbsp;&nbsp;I Confirm
              </label>
            </div>
            <br />
            <Form.Group as={Col}>
              <Button onClick={this.onCheckSubmit}
                className="btn btn-danger">Delete My Account</Button>
            </Form.Group>
          </>
          : <>
            <br />
            <br />
            <br />
            <br />
            <br />
          </> 
        }
        <br />
        <br />
        <br />
        <br />
        <br />
      </ApiUiController>
    );
  }
}
export default DeleteAccount;
